@if (user$ | async; as user) {
<div class="d-flex align-items-center">
  <div class="avatar-wrapper">
    <label for="avatar-input" class="m-0">
      <atx-avatar
        size="m"
        [image]="user.imageLink"
        [fullName]="user.displayName"
        [connectionStatus]="userConnectionStatus$ | async"
      ></atx-avatar>
      <div class="editable-layer" [ngClass]="{ show: avatarLoading$ | async }">
        @if (avatarLoading$ | async) {
        <fa-icon
          [icon]="['fas', 'spinner']"
          [spin]="true"
          [pulse]="true"
        ></fa-icon>
        } @else {
        <fa-icon [icon]="['fas', 'upload']"></fa-icon>
        }
      </div>
    </label>
  </div>
  <div class="d-flex flex-column ml-4">
    <strong class="name" data-e2e="current-user-name">{{
      user.displayName
    }}</strong>
    <span class="email text-muted" data-e2e="current-user-email">{{
      user.email
    }}</span>
  </div>
</div>
}

<input
  #fileInput
  id="avatar-input"
  type="file"
  class="d-none"
  accept="image/*"
  (change)="handleFileSelected($event.target.files[0])"
/>
